// extracted by mini-css-extract-plugin
export default {"imageButton":"_3KszeZH_5Lq2WSw0Kk5H3v"};